import { useEffect } from "react";
import Product from "../../../../../../utilities/data/model/Product";
import { PageItemType } from "../../../../../../utilities/layout";
import { InteractiveQuickKey } from "../../../InteractiveQuickKey";
import { useMakeCommonQuickKeyProps } from "../../hooks";
import { ProductQuickKey } from "../../quick-keys";

export interface ProductItemRendererProps {
  item: PageItemType;
  getProductById: (id: string) => Product;
}

export function ProductItemRenderer({
  item,
  getProductById,
}: ProductItemRendererProps) {
  const { makeCommonQuickKeyProps } = useMakeCommonQuickKeyProps();
  const interactiveProps = makeCommonQuickKeyProps(item);

  const productId = item.config?.productId;

  if (!productId) {
    return null;
  }

  console.log("item", item);

  return (
    <InteractiveQuickKey {...interactiveProps}>
      <ProductQuickKey product={getProductById(productId)} />
    </InteractiveQuickKey>
  );
}
